import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Wifi, Save, Loader2 } from 'lucide-react';
import { toast } from '../hooks/use-toast';
import { HUB_PROPERTIES } from '../pages/guest-hub/hubConfig';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const WifiRow = ({ prop, initial, token }) => {
  const [form, setForm] = useState({ network_name: '', password: '', notes: '', ...initial });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    const res = await fetch(`${API_URL}/api/admin/wifi-settings/${prop.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(form),
    });
    setSaving(false);
    toast({ title: res.ok ? `${prop.name} Wi-Fi saved` : 'Save failed' });
  };

  const field = (key, placeholder) => (
    <Input data-testid={`wifi-${prop.slug}-${key}`} placeholder={placeholder} value={form[key] || ''}
      onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
  );

  return (
    <Card data-testid={`admin-wifi-row-${prop.slug}`}>
      <CardHeader className="pb-3"><CardTitle className="text-base flex items-center gap-2"><Wifi className="h-4 w-4 text-amber-500" />{prop.name}</CardTitle></CardHeader>
      <CardContent className="grid md:grid-cols-4 gap-3">
        {field('network_name', 'Network name')}
        {field('password', 'Password')}
        {field('notes', 'Notes (optional)')}
        <Button data-testid={`wifi-${prop.slug}-save`} onClick={save} disabled={saving} className="bg-slate-900 hover:bg-slate-800">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Save className="h-4 w-4 mr-2" />Save</>}
        </Button>
      </CardContent>
    </Card>
  );
};

const AdminWifi = () => {
  const { token } = useAuth();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/admin/wifi-settings`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => setSettings(Object.fromEntries(data.map((d) => [d.property_id, d]))));
  }, [token]);

  if (!settings) return <Loader2 className="h-8 w-8 animate-spin text-slate-500" />;

  return (
    <div data-testid="admin-wifi-page" className="space-y-4">
      <p className="text-slate-600 text-sm">Changes show instantly on each property's Guest Hub Wi-Fi page.</p>
      {HUB_PROPERTIES.map((p) => <WifiRow key={p.id} prop={p} initial={settings[p.id]} token={token} />)}
    </div>
  );
};

export default AdminWifi;
